(function ($) {
  'use strict';

  $(document).ready(function () {
    // ── Save provider details ──────────────────────────────────────────────────

    $('[data-button-id="save-provider-details"]').on('click', function (e) {
      e.preventDefault();
      $('#loading').addClass('d-flex');

      if (!validateForm()) {
        const $firstError = $(
          '.form-group.error, .material-input.error',
        ).first();
        if ($firstError.length) {
          $('html, body').animate(
            { scrollTop: $firstError.offset().top - 100 },
            500,
          );
        }
        $('#loading').removeClass('d-flex');
        return;
      }

      const formData = new FormData($('#onboarding-form')[0]);
      formData.append('action', 'save_provider_details');

      // Swap the default (empty) file input for the actual staged files
      if (typeof window.getUploadedImages === 'function') {
        formData.delete('product_images[]');
        window
          .getUploadedImages()
          .forEach((file) => formData.append('product_images[]', file));
      }

      $.ajax({
        url: window.ajax_callback_data.ajax_url,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          if (response.success) {
            window.scrollTo({ top: 0 });
            location.reload();
          } else {
            $('#loading').removeClass('d-flex');
          }
        },
        error: function (xhr, status, error) {
          console.error('AJAX Error:', error, xhr.responseText);
          $('#loading').removeClass('d-flex');
        },
      });
    });

    // ── Form validation ────────────────────────────────────────────────────────

    function validateForm() {
      let isValid = true;

      $('.form-group, .material-input, .material-select').removeClass('error');

      // ── Provider Name ─────────────────────────────────────────────────────────
      const providerName = $('#provider_name').val();
      if (!providerName || !providerName.trim()) {
        $('#provider_name')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── Short Description (30–40 words) ───────────────────────────────────────
      const shortDesc = $('#short_description').val().trim();
      let shortDescWords = 0;
      if (shortDesc) {
        shortDescWords = shortDesc.split(/\s+/).filter(w => w.length > 0).length;
      }
      if (!shortDesc || shortDescWords < 30 || shortDescWords > 40) {
        $('#short_description')
          .closest('.form-group, .material-input')
          .addClass('error');
        $('#short_description')
          .closest('.form-group')
          .find('.error-message')
          .text(`Short description must be between 30 and 40 words (currently ${shortDescWords} words).`);
        isValid = false;
      }

      // ── Logo ──────────────────────────────────────────────────────────────────
      const hasExistingLogo = $('#logo_preview').css('display') !== 'none';
      const hasNewLogo =
        $('#logo_file')[0] && $('#logo_file')[0].files.length > 0;
      if (!hasExistingLogo && !hasNewLogo) {
        $('#logo_file').closest('.form-group').addClass('error');
        $('#logo_file')
          .closest('.form-group')
          .find('.error-message')
          .text('A logo is required.');
        isValid = false;
      }

      // ── Primary Location ──────────────────────────────────────────────────────
      const primaryLocation = $('#primary_location').val();
      const primaryAddress = $('#primary_address').val();
      if (!primaryLocation || !primaryLocation.trim()) {
        $('#primary_location')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }
      if (!primaryAddress || !primaryAddress.trim()) {
        $('#primary_address')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── Email ─────────────────────────────────────────────────────────────────
      const email = $('#general_email_address').val();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !email.trim()) {
        $('#general_email_address')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      } else if (!emailRegex.test(email)) {
        $('#general_email_address')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── Phone ─────────────────────────────────────────────────────────────────
      const phone = $('#primary_phone_number').val();
      if (!phone || !phone.trim()) {
        $('#primary_phone_number')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── Age Group (at least 1 checked) ───────────────────────────────────────
      const ageGroupChecked = $('input[name="age_group[]"]:checked').length > 0;
      if (!ageGroupChecked) {
        $('input[name="age_group[]"]')
          .first()
          .closest('.form-group')
          .addClass('error');
        $('input[name="age_group[]"]')
          .first()
          .closest('.form-group')
          .find('.error-message')
          .show();
        isValid = false;
      }

      // ── At least 1 Language ───────────────────────────────────────────────────
      const languagesVal = $('#languages_hidden').val();
      let parsedLanguages = [];
      try {
        parsedLanguages = JSON.parse(languagesVal || '[]');
      } catch (err) {
        parsedLanguages = [];
        if (window.console && typeof console.info === 'function') {
          console.info('Invalid languages JSON format:', err);
        }
      }
      if (!Array.isArray(parsedLanguages) || parsedLanguages.length === 0) {
        $('#language_input')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── Full Description (minimum 80 words) ───────────────────────────────────
      const description = $('#description').val().trim();
      // Strip HTML tags for word count (description uses a rich text editor)
      const descriptionText = description
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      let descriptionWords = 0;
      if (descriptionText.length > 0) {
        descriptionWords = descriptionText.split(/\s+/).filter(w => w.length > 0).length;
      }
      if (!description || descriptionWords < 80) {
        $('#description').closest('.form-group').addClass('error');
        $('#description')
          .closest('.form-group')
          .find('.error-message')
          .text(`Description must be at least 80 words (currently ${descriptionWords} words).`);
        isValid = false;
      }

      // ── At least 1 Tag ────────────────────────────────────────────────────────
      const tagsVal = $('#tags_hidden').val();
      let parsedTags = [];
      try {
        parsedTags = JSON.parse(tagsVal || '[]');
      } catch (err) {
        parsedTags = [];
        if (window.console && typeof console.info === 'function') {
          console.info('Invalid tags JSON format:', err);
        }
      }
      if (!Array.isArray(parsedTags) || parsedTags.length === 0) {
        $('#tag_input')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── URL format (optional) ─────────────────────────────────────────────────
      const url = $('#website_url').val();
      const urlRegex =
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
      if (url && !urlRegex.test(url)) {
        $('#website_url')
          .closest('.form-group, .material-input')
          .addClass('error');
        isValid = false;
      }

      // ── Additional locations — both name and address required if either filled ─
      $('.location-group').each(function () {
        const locationNum = $(this).data('location');
        const locationName = $('#location_' + locationNum).val();
        const locAddress = $('#address_' + locationNum).val();
        if (locationName && !locAddress) {
          $('#address_' + locationNum)
            .closest('.form-group, .material-input')
            .addClass('error');
          isValid = false;
        }
        if (locAddress && !locationName) {
          $('#location_' + locationNum)
            .closest('.form-group, .material-input')
            .addClass('error');
          isValid = false;
        }
      });

      return isValid;
    }

    // ── Auto-clear errors on input ─────────────────────────────────────────────

    $(document).on(
      'input change',
      '.material-input input, .material-input textarea, .material-select select',
      function () {
        $(this)
          .closest('.form-group, .material-input, .material-select')
          .removeClass('error');
      },
    );
  });
})(jQuery);
